export default {
    name: 'v5-icon-star-fill',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M539.978 101.722l114.291 231.579a31.201 31.201 0 0023.492 17.068l255.563 37.135c25.591 3.719 35.809 35.167 17.292 53.218L765.688 620.981a31.2 31.2 0 00-8.973 27.616l43.655 254.53c4.371 25.488-22.38 44.924-45.27 32.89L526.519 815.844a31.197 31.197 0 00-29.037 0L268.899 936.017c-22.889 12.034-49.641-7.403-45.27-32.89l43.655-254.53a31.2 31.2 0 00-8.973-27.616L73.385 440.722c-18.518-18.05-8.299-49.499 17.292-53.218l255.563-37.135a31.201 31.201 0 0023.492-17.068l114.291-231.579c11.443-23.19 44.511-23.19 55.955 0z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
